import { createContext, useContext } from "react";

/**
 * MED-1622: true while a lock screen (unlock, reset or create) covers the
 * page. Pages that refresh on their own (focus, timers) skip it while locked:
 * every API call then answers 423 SESSION_LOCKED.
 */
export const PinLockContext = createContext(false);

export const useScreenLocked = (): boolean => useContext(PinLockContext);
